import React, { useContext, useEffect } from 'react';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import DestinationList  from '../../../subscreens/admin/AdminDestinationManagement/DestinationList';
import DestinationToast from '../../../components/admin/AdminDestinationManagement/DestinationToast';
import '../../../assets/css/admin/adminDestinationManagement/destinationmanagement.css';

const AdminDestinationManagement = () => {
  const { baseUrl, authToken, setDestinations, showDestinationToast, setLoading } = useContext(AppContext);
 
  useEffect(() => {
    if (!authToken) return;
    setLoading(true);
    axios.get(`${baseUrl}/admin/view-destination`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setDestinations(res.data.data || []);
        } else {
          showDestinationToast(res.data.message || 'Failed to fetch destinations', 'error');
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error('Fetch destinations error:', err);
        showDestinationToast('Unable to connect to server', 'error');
      });
  }, [baseUrl, authToken]);

  return (
    <div className="adm-dest-container">
      <DestinationList />
      <DestinationToast />
    </div>
  );
};

export default AdminDestinationManagement;